import { AssetType } from '@droidmap/shared-service-contract'

/** Longest label a box can carry. */
export const MAX_IMAGE_ANNOTATION_LABEL_LENGTH = 100

/** Boxes one image can hold; a guard against a runaway client, not a quota. */
export const MAX_IMAGE_ANNOTATIONS_PER_ASSET = 500

/** Largest page {@link AssetServiceClient.listImageAnnotations} can ask for. */
export const MAX_IMAGE_ANNOTATION_PAGE_SIZE = 1000

/**
 * The asset types a box can be drawn on: the ones a browser can decode. Boxes
 * are in the file's own pixel frame, ignoring any EXIF rotation.
 */
export const ANNOTATABLE_ASSET_TYPES: readonly AssetType[] = [
  AssetType.Jpeg,
  AssetType.Png,
]

/**
 * A box as fractions of the image's width and height, origin top-left. Stored
 * this way so it does not depend on the size the image was displayed at or on
 * knowing the image's pixel dimensions; an exporter converts to pixels.
 */
export type ImageAnnotationBox = {
  x: number
  y: number
  width: number
  height: number
}

export type ImageAnnotation = ImageAnnotationBox & {
  id: string
  assetId: string
  label: string
  created: Date
  createdBy: string
  updated: Date
  updatedBy: string
}

export type ListImageAnnotationsInput = {
  assetSetId: string
  next?: string
  pageSize?: number
}

export type CreateImageAnnotationInput = ImageAnnotationBox & {
  assetSetId: string
  assetId: string
  label: string
}

export type UpdateImageAnnotationInput = Partial<ImageAnnotationBox> & {
  assetSetId: string
  annotationId: string
  label?: string
}

export type DeleteImageAnnotationInput = {
  assetSetId: string
  annotationId: string
}

export type ListNoObjectMarksInput = {
  assetSetId: string
}

/**
 * The images someone reviewed and found nothing to box. Distinct from images
 * nobody has looked at yet: only the former are safe to train on as negatives.
 */
export type NoObjectMarks = {
  assetIds: string[]
}

export type SetNoObjectMarkInput = {
  assetSetId: string
  assetId: string
}
